<template>
  <div class="result">
    <img class="bck pc" :src="selectedIndex == 0 ? bg_pc1 : bg_pc2" />

    <div class="result-top">
      <div class="swiper mobile">
        <Carousel autoplay loop autoplay-speed="3000">
          <CarouselItem>
            <img
                src="@/assets/img/swiper4.jpg"
                alt=""
                class="img"
            />
          </CarouselItem>
          <CarouselItem>
            <img
                src="@/assets/img/swiper5.jpg"
                alt=""
                class="img"
            />
          </CarouselItem>
        </Carousel>
      </div>
    </div>
    <div class="result-bottom mobile">
      <div class="tabs mobile">
        <div style="margin: 0 auto; width: 80%">
          <div
            class="tab-item"
            @click="onTabClick(0)"
            :style="
              selectedIndex == 0 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">漆面膜质保卡</span>
          </div>
          <div
            class="tab-item"
            @click="onTabClick(1)"
            :style="
              selectedIndex == 1 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">太阳膜质保卡</span>
          </div>
        </div>
      </div>

      <template v-if="selectedIndex === 1">
        <template v-if="info.sun.length != 0">
          <mt-navbar v-model="selected">
            <mt-tab-item :id="index+1" v-for="(item,index) in info.sun" :key="index">{{`质保卡${index+1}`}}</mt-tab-item>
          </mt-navbar>

          <!-- tab-container -->
          <mt-tab-container v-model="selected">
            <mt-tab-container-item :id="index+1" v-for="(item,index) in info.sun" :key="index">
              <div class="info">
                <ul class="info-content">
                  <li class="item">
                    <div class="item-name">客户姓名：</div>
                    <div class="item-value">{{ item.own_name }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">客户信息：</div>
                    <div class="item-value">{{ item.vin_no }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">施工主体：</div>
                    <div class="item-value">{{ item.car_type }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">客户电话：</div>
                    <div class="item-value">{{ item.own_phone }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">施工时间：</div>
                    <div class="item-value">{{ item.construction_time }}</div>
                  </li>
                  <li class="arr" v-for="(_item,_index) in item.roll_message" :key="_index">
                    <div class="arr_item" v-show="_item.car_depart_name?true:false">
                      <div class="item-name">施工位置：</div>
                      <div class="item-value">{{ _item.car_depart_name }}</div>
                    </div>
                    <div class="arr_item">
                      <div class="item-name">卷膜名称：</div>
                      <div class="item-value">{{ _item.roll_name }}</div>
                    </div>
                    <div class="arr_item">
                      <div class="item-name">卷膜编码：</div>
                      <div class="item-value">{{ _item.roll_film_number }}</div>
                    </div>
                    <div class="arr_item">
                      <div class="item-name">质保时间：</div>
                      <div class="item-value">{{ _item.warranty_year*1 }}年</div>
                    </div>
                  </li>
                </ul>
              </div>
            </mt-tab-container-item>
          </mt-tab-container>
          <img
            src="@/assets/img/bg_mb2.jpg"
            style="margin-top: 0.6rem; position: relative; left: -0.4rem"
          />
        </template>
        <div class="default mobile" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
      <template v-if="selectedIndex === 0">
        <template
          v-if="info.protected.length != 0"
        >
          <mt-navbar v-model="selected">
            <mt-tab-item :id="index+1" v-for="(item,index) in info.protected" :key="index">{{`质保卡${index+1}`}}</mt-tab-item>
          </mt-navbar>

          <!-- tab-container -->
          <mt-tab-container v-model="selected">
            <mt-tab-container-item :id="index+1" v-for="(item,index) in info.protected" :key="index">
              <div class="info">
                <ul class="info-content">
                  <li class="item">
                    <div class="item-name">客户姓名：</div>
                    <div class="item-value">{{ item.own_name }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">客户信息：</div>
                    <div class="item-value">{{ item.vin_no }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">施工主体：</div>
                    <div class="item-value">{{ item.car_type }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">客户电话：</div>
                    <div class="item-value">{{ item.own_phone }}</div>
                  </li>
                  <li class="item">
                    <div class="item-name">施工时间：</div>
                    <div class="item-value">{{ item.construction_time }}</div>
                  </li>
                  <li class="arr" v-for="(_item,_index) in item.roll_message" :key="_index">
                    <div class="arr_item" v-show="_item.car_depart_name?true:false">
                      <div class="item-name">施工位置：</div>
                      <div class="item-value">{{ _item.car_depart_name }}</div>
                    </div>
                    <div class="arr_item">
                      <div class="item-name">卷膜名称：</div>
                      <div class="item-value">{{ _item.roll_name }}</div>
                    </div>
                    <div class="arr_item">
                      <div class="item-name">卷膜编码：</div>
                      <div class="item-value">{{ _item.roll_film_number }}</div>
                    </div>
                    <div class="arr_item">
                      <div class="item-name">质保时间：</div>
                      <div class="item-value">{{ _item.warranty_year*1 }}年</div>
                    </div>
                  </li>
                </ul>
              </div>
            </mt-tab-container-item>
          </mt-tab-container>
          <img
            src="@/assets/img/bg_mb3.jpg"
            style="margin-top: 0.6rem; position: relative; left: -0.4rem"
          />
        </template>
        <div class="default mobile" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
    </div>
    <div class="result-bottom pc">
      <div class="tabs pc">
        <div style="margin: 0 auto; width: 80%">
          <div
            class="tab-item"
            @click="onTabClick(0)"
            :style="
              selectedIndex == 0 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">漆面膜质保卡</span>
          </div>
          <div
            class="tab-item"
            @click="onTabClick(1)"
            :style="
              selectedIndex == 1 ? { background: '#fff', color: 'black' } : {}
            "
          >
            <span class="tab-item-content">太阳膜质保卡</span>
          </div>
        </div>
      </div>

      <template v-if="selectedIndex === 1">
        <template v-if="info.sun.length != 0">
          <Tabs value="1">
            <TabPane :label="`质保卡${index+1}`" :name="`${index+1}`" v-for="(item,index) in info.sun" :key="index">  <div class="info">
              <ul class="info-content">
                <li class="item">
                  <div class="item-name">客户姓名：</div>
                  <div class="item-value">{{ item.own_name }}</div>
                </li>
                <li class="item">
                  <div class="item-name">客户信息：</div>
                  <div class="item-value">{{ item.vin_no }}</div>
                </li>
                <li class="item">
                  <div class="item-name">施工主体：</div>
                  <div class="item-value">{{ item.car_type }}</div>
                </li>
                <li class="item">
                  <div class="item-name">客户电话：</div>
                  <div class="item-value">{{ item.own_phone }}</div>
                </li>
                <li class="item">
                  <div class="item-name">施工时间：</div>
                  <div class="item-value">{{ item.construction_time }}</div>
                </li>
                <li class="arr" v-for="(_item,_index) in item.roll_message" :key="_index">
                  <div class="arr_item" v-show="_item.car_depart_name?true:false">
                    <div class="item-name">施工位置：</div>
                    <div class="item-value">{{ _item.car_depart_name }}</div>
                  </div>
                  <div class="arr_item">
                    <div class="item-name">卷膜名称：</div>
                    <div class="item-value">{{ _item.roll_name }}</div>
                  </div>
                  <div class="arr_item">
                    <div class="item-name">卷膜编码：</div>
                    <div class="item-value">{{ _item.roll_film_number }}</div>
                  </div>
                  <div class="arr_item">
                    <div class="item-name">质保时间：</div>
                    <div class="item-value">{{ _item.warranty_year*1 }}年</div>
                  </div>
                </li>
              </ul>
            </div></TabPane>
          </Tabs>
        </template>
        <div class="default pc" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
      <template v-if="selectedIndex === 0">
        <template
          v-if="info && info.protected.length != 0"
        >
          <Tabs value="1">
            <TabPane :label="`质保卡${index+1}`" :name="`${index+1}`" v-for="(item,index) in info.protected" :key="index">  <div class="info">
              <ul class="info-content">
                <li class="item">
                  <div class="item-name">客户姓名：</div>
                  <div class="item-value">{{ item.own_name }}</div>
                </li>
                <li class="item">
                  <div class="item-name">客户信息：</div>
                  <div class="item-value">{{ item.vin_no }}</div>
                </li>
                <li class="item">
                  <div class="item-name">施工主体：</div>
                  <div class="item-value">{{ item.car_type }}</div>
                </li>
                <li class="item">
                  <div class="item-name">客户电话：</div>
                  <div class="item-value">{{ item.own_phone }}</div>
                </li>
                <li class="item">
                  <div class="item-name">施工时间：</div>
                  <div class="item-value">{{ item.construction_time }}</div>
                </li>
                <li class="arr" v-for="(_item,_index) in item.roll_message" :key="_index">
                  <div class="arr_item" v-show="_item.car_depart_name?true:false">
                  <div class="item-name">施工位置：</div>
                  <div class="item-value">{{ _item.car_depart_name }}</div>
                  </div>
                  <div class="arr_item">
                    <div class="item-name">卷膜名称：</div>
                    <div class="item-value">{{ _item.roll_name }}</div>
                  </div>
                  <div class="arr_item">
                    <div class="item-name">卷膜编码：</div>
                    <div class="item-value">{{ _item.roll_film_number }}</div>
                  </div>
                  <div class="arr_item">
                    <div class="item-name">质保时间：</div>
                    <div class="item-value">{{ _item.warranty_year*1 }}年</div>
                  </div>
                </li>
              </ul>
            </div></TabPane>
          </Tabs>
        </template>
        <div class="default pc" v-else>
          <img class="default-img" src="@/assets/img/default.png" alt />
          <div class="default-text">尚未查询到相关信息~</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      selected:1,
      info: null,
      selectedIndex: 0,
      mbMobileBanner: [],
      canBannerClick: false,
      bg_pc1: require('../../assets/img/bg_pc2.jpg'),
      bg_pc2: require('../../assets/img/bg_pc3.jpg'),
    };
  },
  methods: {
    onTabClick(index) {
      this.selectedIndex = index;
    },
  },
  created() {
    let info = JSON.parse(localStorage.getItem('info'));
    if(info['35']){
       info['35'].forEach(v=>{
         if(!v.roll_message){
           v.roll_message = [];
         }
       })
    }
    if(info['34']){
      info['34'].forEach(v=>{
        if(!v.roll_message){
          v.roll_message = [];
        }
      })
    }
    let data = {
      protected:info['35']?info['35']:[],
      sun:info['34']?info['34']:[]
    }
    // let ob = JSON.parse(JSON.stringify(data.protected[0]));
    // let ar = JSON.parse(JSON.stringify(data.protected[0].roll_message));
    // data.protected.push(ob)
    // data.protected[0].roll_message.push(...ar)
    // data.sun = data.protected
    // console.log(data)
    // // 测试
    // info = {
    //   sun: {
    //     id: 2,
    //     user_phone: "13735474850",
    //     user_name: "测试姓名",
    //     car_sn: "1234",
    //     car_type: "兰博基尼",
    //     start_time: "2020/01/17",
    //     end_time: "2020/01/17",
    //     qian_sn: "1234",
    //     hou_sn: "1234",
    //     mo_type: 0,
    //     is_empty: 0,
    //     city: '杭州'
    //   },
    //   protected: {
    //     id: 1,
    //     user_phone: "13735474850",
    //     user_name: "测试姓名",
    //     car_sn: "1234",
    //     car_type: "兰博基尼",
    //     start_time: "2020/01/17",
    //     end_time: "2020/01/17",
    //     set_meal_name_a: "豪华套餐",
    //     set_meal_name_b: "总统套餐",
    //     pro_sn: "1231",
    //     mo_type: 1,
    //     is_empty: 0
    //   }
    // };

    this.$set(this, "info", data);
    // this.canBannerClick = this.info && this.info.sun && this.info.sun.city === '杭州市'
    // if (this.canBannerClick) {
  }
};
</script>

<style scoped lang="scss">
.result {
  width: 100%;
  height: 100%;
  // overflow: hidden;
}
.result .result-top {
  width: 100%;
  position: relative;
}
@media screen and (min-width: 100px) and (max-width: 640px) {
  .result .pc {
    display: none !important;
  }
  .result .result-top {
    height: 2.4rem;
    text-align: center;
    overflow: hidden;
  }
  .result .result-top .swiper {
    width: 100%;
    height: 2.4rem;
    position: relative;
  }
  .result .result-top .swiper .img {
    height: calc(100%);
    width: calc(100%);
  }
  .result .result-top .swiper .activity {
    height: calc(100%);
    width: auto;
    position: absolute;
    right: 0.2rem;
    top: 0;
  }
  .result .result-bottom {
    padding: 0 0.24rem 0.24rem;
  }
  .result .result-bottom .tabs {
    width: 7.02rem;
    height: 0.98rem;
    position: relative;
    margin-top: 0.48rem;
    text-align: center;
    background: linear-gradient(
      to top,
      rgb(102, 100, 100) 0%,
      rgb(239, 236, 236) 100%
    );
    box-shadow: 0px 6px 20px 0px rgba(23, 23, 23, 0.25);
    border-radius: 0.1rem;
  }
  .result .result-bottom .tabs .tab-item {
    width: 50%;
    height: 0.98rem;
    // border-left: 0.1rem solid black;
    // border-right: 0.1rem solid black;
    background: #e0dddd;
    box-sizing: border-box;
    transform: skew(-20deg);
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    display: inline-block;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    line-height: 0.98rem;
    text-align: center;
  }
  .result .result-bottom .tabs .tab-item .tab-item-content {
    display: inline-block;
    transform: skew(20deg);
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -o-transform: skew(20deg);
    -ms-transform: skew(20deg);
  }
  .result .result-bottom .tabs .tab-item:first-child {
    left: 0;
  }
  .result .result-bottom .tabs .tab-item:last-child {
    left: 50%;
  }
  .result .result-bottom .tabs .active-bg {
    width: 50%;
    height: 0.98rem;
    position: absolute;
    top: 0;
    border-radius: 0.49rem;
    background: linear-gradient(
      0deg,
      rgba(199, 41, 51, 1) 0%,
      rgba(222, 133, 140, 1) 100%
    );
    transition: left 0.2s;
    -webkit-transition: left 0.2s; /* Safari */
  }
  .result .result-bottom .info {
    margin-top: 0.36rem;
  }
  .result .result-bottom .info .info-title {
    height: 0.29rem;
  }
  .result .result-bottom .info .info-title > div {
    display: inline-block;
  }
  .result .result-bottom .info .info-title .line {
    width: 0.07rem;
    height: 0.2rem;
    margin-top: 0.04rem;
    background: rgba(21, 21, 21, 1);
    border-radius: 0.04rem;
  }
  .result .result-bottom .info .info-title .text {
    width: 2rem;
    height: 0.29rem;
    margin-left: 0.24rem;
    font-size: 0.3rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 0.29rem;
  }
  .result .result-bottom .info .info-content {
    width: 7rem;
    margin: 0.35rem auto 0;
  }
  .result .result-bottom .info .info-content .arr {
    width: 100%;
    height: auto;
    margin-top: .24rem;
    background: linear-gradient(
            to top,
            rgb(180, 178, 178) 0%,
            rgb(255, 255, 255) 100%
    );
    box-shadow: 0 0.01rem 0.3rem 0 rgba(204, 204, 204, 0.35);
    border-radius: 0.18rem;
    .arr_item{
      display: flex;
      .item-name {
        width: 1.6rem;
        height: 0.64rem;
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 40px;
        opacity: 0.7;
        text-align: right;
        vertical-align: top;
      }
      .item-value {
        width: 3rem;
        height: 0.64rem;
        box-sizing: border-box;
        padding-left: 0.6rem;
        line-height: 40px;
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        opacity: 0.9;
        text-align: left;
        white-space: nowrap;
      }
    }
  }
  .result .result-bottom .info .info-content .item {
    width: 100%;
    height: 0.64rem;
    margin-top: 0.24rem;
    background: linear-gradient(
      to top,
      rgb(180, 178, 178) 0%,
      rgb(255, 255, 255) 100%
    );
    box-shadow: 0 0.01rem 0.3rem 0 rgba(204, 204, 204, 0.35);
    border-radius: 0.1rem;
  }
  .result .result-bottom .info .info-content .item > div {
    display: inline-block;
  }
  .result .result-bottom .info .info-content .item > .item-name {
    width: 1.6rem;
    height: 0.64rem;
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 0.64rem;
    opacity: 0.7;
    text-align: right;
    vertical-align: top;
  }
  .result .result-bottom .info .info-content .item > .item-value {
    width: 3rem;
    height: 0.64rem;
    box-sizing: border-box;
    padding-left: 0.6rem;
    line-height: 0.64rem;
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.9;
    text-align: left;
    white-space: nowrap;
  }
  .result .result-bottom .default .default-img {
    width: 2.5rem;
    height: 1.97rem;
    margin: 0.65rem auto 0;
  }
  .result .result-bottom .default .default-text {
    width: 100%;
    height: 0.23rem;
    margin-top: 0.27rem;
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.4;
    text-align: center;
  }
}
@media screen and (min-width: 641px) {
  .result {
    overflow: hidden;
  }
  .result .mobile {
    display: none !important;
  }
  .result-top {
    display: none;
  }
  .bck {
    width: 100%;
    z-index: 0;
  }
  .result .result-bottom {
    // padding: 0 0.24rem 0.24rem;
    background: rgba(194, 193, 193, 0.475);
    width: 400px;
    position: absolute;
    top: 18%;
    left: 50%;
    border-radius: 5px;
  }
  .result .result-bottom .tabs {
    width: 100%;
    height: 50px;
    position: relative;
    text-align: center;
    background: linear-gradient(
      to top,
      rgb(102, 100, 100) 0%,
      rgb(239, 236, 236) 100%
    );
    box-shadow: 0px 6px 20px 0px rgba(23, 23, 23, 0.25);
    border-radius: 5px;
  }
  .result .result-bottom .tabs .tab-item {
    width: 50%;
    height: 50px;
    display: inline-block;
    transform: skew(-20deg);
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    background: #e0dddd;
    color: rgba(255, 255, 255, 1);
    line-height: 50px;
    text-align: center;
  }
  .result .result-bottom .tabs .tab-item .tab-item-content {
    display: inline-block;
    transform: skew(20deg);
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -o-transform: skew(20deg);
    -ms-transform: skew(20deg);
    cursor: pointer;
  }
  .result .result-bottom .tabs .tab-item:first-child {
    left: 0;
  }
  .result .result-bottom .tabs .tab-item:last-child {
    left: 50%;
  }
  // .result .result-bottom .tabs .active-bg {
  //   width: 50%;
  //   height: 0.98rem;
  //   position: absolute;
  //   top: 0;
  //   border-radius: 0.49rem;
  //   background: linear-gradient(
  //     0deg,
  //     rgba(199, 41, 51, 1) 0%,
  //     rgba(222, 133, 140, 1) 100%
  //   );
  //   transition: left 0.2s;
  //   -webkit-transition: left 0.2s; /* Safari */
  // }
  // .result .result-bottom .info {
  //   margin-top: 0.36rem;
  // }
  // .result .result-bottom .info .info-title {
  //   height: 0.29rem;
  // }
  // .result .result-bottom .info .info-title > div {
  //   display: inline-block;
  // }
  // .result .result-bottom .info .info-title .line {
  //   width: 0.07rem;
  //   height: 0.2rem;
  //   margin-top: 0.04rem;
  //   background: rgba(21, 21, 21, 1);
  //   border-radius: 0.04rem;
  // }
  // .result .result-bottom .info .info-title .text {
  //   width: 2rem;
  //   height: 0.29rem;
  //   margin-left: 0.24rem;
  //   font-size: 0.3rem;
  //   font-family: PingFang SC;
  //   font-weight: 600;
  //   color: rgba(0, 0, 0, 1);
  //   line-height: 0.29rem;
  // }
  .result .result-bottom .info .info-content {
    width: 400px;
    margin: 0 auto;
    height: 430px;
    overflow: auto;
  }
  .result .result-bottom .info .info-content::-webkit-scrollbar{
    width: 10px;
    background: radial-gradient(#9f9d9d, transparent);
  }
  .result .result-bottom .info .info-content::-webkit-scrollbar-thumb{
    background: #a9a9a9;
    border-radius: 10px;
  }
  .result .result-bottom .info .info-content .item {
    width: 100%;
    height: 40px;
    margin-top: 10px;
    background: rgba(240, 240, 240, 1);
    // box-shadow: 0 0.01rem 0.3rem 0 rgba(204, 204, 204, 0.35);
    border-radius: 5px;
  }
  .result .result-bottom .info .info-content .arr {
    width: 100%;
    height: auto;
    margin-top: .05rem;
    background: linear-gradient(
            to top,
            rgb(180, 178, 178) 0%,
            rgb(255, 255, 255) 100%
    );
    box-shadow: 0 0.01rem 0.3rem 0 rgba(204, 204, 204, 0.35);
    border-radius: 0.03rem;
    .arr_item{
      display: flex;
      .item-name {
        width: 100px;
        height: 40px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 40px;
        opacity: 0.7;
        text-align: right;
        vertical-align: top;
      }
       .item-value {
        width: 280px;
        height: 40px;
        box-sizing: border-box;
        padding-left: 20px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        opacity: 0.9;
        text-align: left;
        white-space: nowrap;
      }
    }
  }
  .result .result-bottom .info .info-content .item > div {
    display: inline-block;
  }
  .result .result-bottom .info .info-content .item > .item-name {
    width: 100px;
    height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 40px;
    opacity: 0.7;
    text-align: right;
    vertical-align: top;
  }
  .result .result-bottom .info .info-content .item > .item-value {
    width: 280px;
    height: 40px;
    box-sizing: border-box;
    padding-left: 20px;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.9;
    text-align: left;
    white-space: nowrap;
  }
  .result .result-bottom .default .default-img {
    width: 130px;
    height: 100px;
    margin: 130px auto 0;
  }
  .result .result-bottom .default .default-text {
    width: 100%;
    height: 130px;
    margin-top: 40px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    opacity: 0.4;
    text-align: center;
  }
}
/deep/.ivu-tabs-bar{
  margin: 0;
}
/deep/.ivu-tabs-nav .ivu-tabs-tab-active{
  color: black !important;
}
/deep/.ivu-tabs-nav .ivu-tabs-tab{
  color: #ac9f9f;
  font-weight: bold;
}
/deep/.ivu-tabs-ink-bar{
  background-color: #fdfcfc;
}
/deep/.mint-navbar .mint-tab-item.is-selected{
  margin-bottom: 0;
  color: #ac9f9f !important;
}
/deep/.mint-navbar .mint-tab-item.is-selected .mint-tab-item-label{
  color: black !important;
}
/deep/.mint-navbar .mint-tab-item{
  padding: .3rem 0 ;
}
/deep/.mint-tab-item-label{
  font-size: .28rem;
  font-weight: bold;
  color: #b2b0b0;
}
/deep/.mint-navbar .mint-tab-item.is-selected{
  border-bottom: 3px solid #b2b0b0;
}
</style>
